<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="融租" name="financialLease">
        <base-list-management
          ref="financialBaseListManagement"
          :configData.sync="financialLeaseConfig"
        />
      </el-tab-pane>
      <el-tab-pane label="经租" name="economicLease">
        <base-list-management
          ref="economicBaseListManagement"
          :configData.sync="economicLeaseConfig"
        />
      </el-tab-pane>
    </el-tabs>
    <cooperateDialog :show.sync="cooperateShow" :planId="cooperatePlanId" />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { carBrandList, carSeriesList } from '@/api/domain/organize'
import { getCityList } from '@/api/domain/cars'
import { mapState } from 'vuex'
import cooperateDialog from './components/cooperateDialog.vue'
import { financialLeaseConfigFn, economicLeaseConfigFn, TABS, REF_CONFIG, TAB_REF } from './config'

export default {
  components: {
    cooperateDialog,
  },
  data() {
    const financialLeaseConfig = financialLeaseConfigFn.call(this)
    const economicLeaseConfig = economicLeaseConfigFn.call(this)
    return {
      // tab标识
      activeName: 'financialLease',
      // 合作咨询弹窗
      cooperateShow: false,
      // 合作咨询方案ID
      cooperatePlanId: null,
      financialLeaseConfig,
      economicLeaseConfig,
    }
  },
  methods: {
    // 切换Tab
    handleClick(tab) {
      // 避免base-list-management首次mounted时自动调接口
      if (!this.$refs.economicBaseListManagement) {
        return
      }
      this.$nextTick(() => {
        const ref = TAB_REF[tab.name]
        this.$refs[ref].reset()
      })
    },
    financialReset() {
      this.$refs.financialBaseListManagement.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },
    economicReset() {
      this.$refs.economicBaseListManagement.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },
    // 获取城市
    getCities() {
      getCityList().then((res) => {
        if (res?.code === 1) {
          this.financialLeaseConfig.formData.list.find((item) => item.itemConfig.prop === 'transactionCity').elConfig.options.list = res?.data || []
          this.economicLeaseConfig.formData.list.find((item) => item.itemConfig.prop === 'transactionCity').elConfig.options.list = res?.data || []
        }
      })
    },
    dealWithSearch(params) {
      const { brandSeriesModel } = params
      const searchParams = {
        ...params,
        brandId: brandSeriesModel?.brandId,
        seriesId: brandSeriesModel?.seriesId,
        modelId: brandSeriesModel?.modelId,
        leaseType: TABS[this.activeName],
      }
      delete searchParams.brandSeriesModel
      return searchParams
    },
    // 初始化筛选项
    initFilters() {
      const filters = ['financialInstitution', 'repaymentMethod', 'leaseModel']
      filters.forEach((item) => {
        if (this[item].length === 0) {
          this.$store.dispatch('getCarResourceEnum', item).then((res) => {
            this.$refs.financialBaseListManagement?.setItemData({ elConfigKey: 'list', key: item, data: res })
          })
        } else {
          this.$refs.financialBaseListManagement?.setItemData({ elConfigKey: 'list', key: item, data: this[item] })
        }
      })
    },
    // 方案来源
    goDetail({ carResourceId, leaseType }) {
      this.$router.push({
        path: '/purchaseOrder/resourceCenter/detail',
        query: { carResourceId, leaseType },
      })
    },
    // 盈收测算
    goCalculate(id) {
      this.$router.push({
        path: '/purchaseOrder/resourceCenter/calculate',
        query: { id, leaseType: TABS[this.activeName] },
      })
    },
    // 展示合作咨询弹窗
    showOperateDialog(id) {
      this.cooperateShow = true
      this.cooperatePlanId = id
    },
  },
  computed: {
    ...mapState({
      financialInstitution: (state) => state.carResource.financialInstitution,
      repaymentMethod: (state) => state.carResource.repaymentMethod,
      leaseModel: (state) => state.carResource.leaseModel,
    }),
  },
  created() {
    this.getCities()
  },
  mounted() {
    this.initFilters()
  },
}
</script>
